import { useState } from "react";
import { setupStyles } from "./setupStyles";
import "./TiendaSetupPage.css";
import TabContactoTienda from "./ContactoTienda";
import SetupTabContenidoLegal from "./TabContenidoLegal";
import SetupTabConfiguracion from "./TabConfiguracion";
import BrandingLauncher from "./BrandingLauncher";
import SetupTabAssets from "./SetupTabAssets";
import SetupTabInicio from "./TabInicio";

const svgProps = {
  width: 18,
  height: 18,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.9,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
};

const IconInicio = () => (
  <svg {...svgProps}>
    <path d="M3 9.5 12 3l9 6.5" />
    <path d="M5 9.5V21h14V9.5" />
    <path d="M9 21v-6h6v6" />
  </svg>
);

const IconContacto = () => (
  <svg {...svgProps}>
    <path d="M21 15.5a2 2 0 0 1-2 2 16 16 0 0 1-7-2.5 16 16 0 0 1-5-5A16 16 0 0 1 4.5 3 2 2 0 0 1 6.5 1h2a2 2 0 0 1 2 1.7c.1.9.3 1.7.6 2.5a2 2 0 0 1-.5 2.1L9.5 9.5a13 13 0 0 0 5 5l1.2-1.2a2 2 0 0 1 2.1-.5c.8.3 1.6.5 2.5.6a2 2 0 0 1 1.7 2Z" />
  </svg>
);

const IconLegal = () => (
  <svg {...svgProps}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
    <path d="M9 13h6" />
    <path d="M9 17h6" />
  </svg>
);

const IconConfig = () => (
  <svg {...svgProps}>
    <path d="M4 6h11" />
    <path d="M19 6h1" />
    <circle cx="17" cy="6" r="2" />
    <path d="M4 12h3" />
    <path d="M11 12h9" />
    <circle cx="9" cy="12" r="2" />
    <path d="M4 18h11" />
    <path d="M19 18h1" />
    <circle cx="17" cy="18" r="2" />
  </svg>
);

const IconBranding = () => (
  <svg {...svgProps}>
    <path d="M12 3a9 9 0 1 0 0 18c.9 0 1.5-.7 1.5-1.5 0-.4-.2-.8-.4-1.1-.3-.3-.4-.7-.4-1.1 0-.8.7-1.5 1.5-1.5H16a4 4 0 0 0 4-4c0-4.4-3.6-7.3-8-7.3Z" />
    <circle cx="7.5" cy="11" r="1" />
    <circle cx="10.5" cy="7.5" r="1" />
    <circle cx="14.5" cy="7.5" r="1" />
  </svg>
);

const IconAssets = () => (
  <svg {...svgProps}>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="9" cy="9" r="1.6" />
    <path d="m21 15-5-5L5 21" />
  </svg>
);

const TABS = [
  { id: "inicio", label: "Pantalla de inicio", Icon: IconInicio },
  { id: "redes", label: "Contacto", Icon: IconContacto },
  { id: "legal", label: "Contenido legal", Icon: IconLegal },
  { id: "config", label: "Configuración", Icon: IconConfig },
  { id: "branding", label: "Branding", Icon: IconBranding },
  { id: "assets", label: "Assets", Icon: IconAssets },
];

function TiendaSetupPage() {
  const [tab, setTab] = useState("inicio");
  const activeTab = TABS.find((t) => t.id === tab) || TABS[0];

  return (
    <div className="tienda-page-scope">
      <div className="tienda-setup-scope">
        <style>{setupStyles}</style>

        <header className="tienda-setup-header">
          <span className="tienda-setup-kicker">Configuración</span>
          <h1 className="tienda-setup-title">Configuración de la tienda</h1>
          <p className="tienda-setup-sub">
            Edita la página de inicio pública, el contacto, el branding y más. Cada pestaña se
            guarda con su propio botón.
          </p>
        </header>

        <div className="tienda-setup-tabs" role="tablist" aria-label="Secciones de configuración">
          {TABS.map((t) => {
            const isActive = tab === t.id;
            return (
              <button
                key={t.id}
                type="button"
                role="tab"
                aria-selected={isActive}
                className={`tienda-setup-tab ${isActive ? "tienda-setup-tab-active" : ""}`}
                onClick={() => setTab(t.id)}
              >
                <span className="tienda-setup-tab__icon">
                  <t.Icon />
                </span>
                <span className="tienda-setup-tab__label">{t.label}</span>
              </button>
            );
          })}
        </div>

        <div className="tienda-setup-formcard" role="tabpanel" aria-label={activeTab.label}>
          {tab === "inicio" && <SetupTabInicio />}
          {tab === "redes" && <TabContactoTienda />}
          {tab === "legal" && <SetupTabContenidoLegal />}
          {tab === "config" && <SetupTabConfiguracion />}
          {tab === "branding" && <BrandingLauncher />}
          {tab === "assets" && <SetupTabAssets />}
        </div>
      </div>
    </div>
  );
}

export default TiendaSetupPage;
